var _circle, _path, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRight180 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 68 68",
    height: 68,
    width: 68,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.1,
    fill: "#000000",
    transform: "rotate(-90)",
    r: 25,
    cy: 34,
    cx: -34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#000000",
    d: "m 9,34 c 0,3.283 0.64665,6.5339 1.903,9.5671 1.2564,3.0331 3.0979,5.7891 5.4193,8.1106 2.3215,2.3214 5.0775,4.1629 8.1106,5.4193 C 27.4661,58.3534 30.717,59 34,59 c 3.2831,0 6.5339,-0.6466 9.5671,-1.903 3.0331,-1.2564 5.7891,-3.0979 8.1106,-5.4193 2.3214,-2.3215 4.1629,-5.0775 5.4193,-8.1106 C 58.3534,40.5339 59,37.283 59,34 Z",
    className: "filled"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    r: 4,
    cy: 34,
    cx: 34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 6,
    stroke: "#000000",
    d: "m 9,34 c 0,6.6304 2.6339,12.9893 7.3223,17.6777 C 21.0107,56.3661 27.3696,59 34,59 40.6304,59 46.9893,56.3661 51.6777,51.6777 56.3661,46.9893 59,40.6304 59,34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 6,
    stroke: "#000000",
    d: "M 16.1386,38.1919 9.56353,33.2577 3,38.187"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRight180);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Right180.cf6607d3932b27f56aff35931146e6b3.svg";